export const baseUrl: string = "https://api.scanner.myheadhealth.com"

export const headers: Record<string, string> = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
}
